import React from "react";
import "./terms.css";

import logoWhite from './logo_white.png';

const CancellationPolicy = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top px-3">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img
              src={logoWhite}
              alt="KeyConnect Logo"
              style={{ height: "40px", marginLeft: "20px" }}
            />
          </a>
        </div>
      </nav>

      <section className="legal-page">
        <div className="wrap">
          <h1>Cancellation Policy</h1>

          <div className="legal-meta">
            <div>
              <strong>Effective Date:</strong> 8<sup>th</sup> July 2025
            </div>
            <div>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.keyconnect.in
              </a>
            </div>
            <div>
              <strong>Platform:</strong> KeyConnect CRM
            </div>
          </div>

          <p>
            By subscribing to or using the KeyConnect CRM platform, you
            agree to comply with this policy in full and the terms stated in
            this policy.
          </p>

          <section>
            <h2>1. Prepaid Subscription Plans</h2>
            <p>
              All KeyConnect CRM plans —{" "}
              <strong>Monthly, Quarterly, Bi-Annual, and Annual</strong> —
              are strictly <strong>Pre-paid</strong>. Services are activated
              only after successful payment for the entire billing cycle.
              No "pay-as-you-go" or Post-paid options are offered.
            </p>
          </section>

          <section>
            <h2>2. Cancellation by Client</h2>
            <p>
              <strong>General Terms</strong>
            </p>
            <ul>
              <li>
                Clients may cancel their subscription at any time by
                sending a written request to:{" "}
                <a href="mailto:support@keyconnect.in">support@keyconnect.in</a>
              </li>
              <li>
                All plans are prepaid. Therefore,{" "}
                <strong>no refunds</strong> will be provided for
                cancellations made after the applicable grace period,
                regardless of usage.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. Refund Eligibility – Period</h2>
            <p>
              Clients may cancel their subscription within 7 calendar days
              from the date of account activation or renewal to be eligible
              for a refund, subject to applicable deductions.
            </p>
          </section>

          <section>
            <h2>4. Refund Calculation (If Eligible Within Period)</h2>
            <p>
              If cancellation is requested within the applicable period, a{" "}
              <strong>partial refund</strong> may be issued{" "}
              <strong>after deductions</strong>, which may include:
            </p>
            <ul>
              <li>Setup and onboarding charges</li>
              <li>Platform usage and admin overhead</li>
              <li>Applicable government taxes</li>
              <li>
                <strong>Third-party integration charges</strong> (e.g., SMS
                gateway, WhatsApp API, IVR setup, Meta integrations)
              </li>
            </ul>
            <p>
              <strong>Note:</strong> Third-party integration charges are{" "}
              <strong>strictly non-refundable</strong>, even if the
              cancellation is initiated within the refund-eligible grace
              period.
            </p>
          </section>

          <section>
            <h2>5. No Refund After Grace Period</h2>
            <p>
              Cancellations made after the grace period are{" "}
              <strong>not eligible</strong> for any refund. Services will
              remain active until the end of the current billing cycle,
              after which access will be revoked.
            </p>
          </section>

          <section>
            <h2>6. Termination by KeyConnect CRM</h2>
            <p>
              We reserve the right to suspend or terminate Client access to
              the platform for the following reasons:
            </p>

            <p>
              <strong>a. Non-Payment</strong>
            </p>
            <ul>
              <li>
                Access may be suspended if payment fails or is delayed
                beyond the due date.
              </li>
              <li>
                If payment is not received within <strong>7 days</strong> of
                the due date, the account may be{" "}
                <strong>terminated permanently</strong>.
              </li>
            </ul>

            <p>
              <strong>b. Violation of Terms or Policy</strong>
            </p>
            <ul>
              <li>
                Any breach of our Terms &amp; Conditions, CRM Usage Policy,
                or applicable law may result in immediate account
                termination without refund.
              </li>
            </ul>

            <p>
              <strong>c. Misuse or Abuse</strong>
            </p>
            <ul>
              <li>
                Platform misuse, unauthorized system access, or abuse of
                third-party APIs may lead to account deactivation.
              </li>
            </ul>

            <p>
              <strong>d. Service Discontinuation</strong>
            </p>
            <ul>
              <li>
                If we discontinue or sunset the KeyConnect CRM platform,
                Clients will be provided{" "}
                <strong>30 days' advance notice</strong> and an opportunity
                to export their data.
              </li>
            </ul>
          </section>

          <section>
            <h2>7. Data Retention &amp; Export</h2>
            <ul>
              <li>
                After cancellation or termination, Clients will have{" "}
                <strong>7 business days</strong> to request and download
                their data.
              </li>
              <li>
                After this period, all data will be{" "}
                <strong>permanently deleted</strong> within{" "}
                <strong>30 calendar days</strong>, unless retention is
                legally required.
              </li>
            </ul>
          </section>

          <section>
            <h2>8. Outstanding Dues</h2>
            <ul>
              <li>
                Clients must settle any outstanding payments within{" "}
                <strong>10 business days</strong> of cancellation or
                termination.
              </li>
              <li>
                Unpaid dues may result in legal recovery or denial of
                future services.
              </li>
            </ul>
          </section>

          <section>
            <h2>9. Reinstatement Policy</h2>
            <ul>
              <li>
                Suspended accounts may be reinstated within{" "}
                <strong>15 calendar days</strong>, subject to:
                <ul>
                  <li>Full payment of dues</li>
                  <li>Payment of reactivation or administrative fees</li>
                  <li>Internal review and approval by our billing team</li>
                </ul>
              </li>
            </ul>
            <p>
              Reinstatement is not guaranteed and is subject to our
              discretion.
            </p>
          </section>

          <section>
            <h2>10. Policy Revisions and Updates</h2>
            <p>
              This policy may be updated from time to time. Changes will be
              published on our website with a revised effective date.
              Continued use after changes constitutes acceptance of the
              updated policy.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              For all cancellation, refund, or termination inquiries,
              please contact:
            </p>
            <p>
              <strong>KeyConnect CRM – Billing &amp; Client Services</strong>
              <br />
              Email:{" "}
              <a href="mailto:support@keyconnect.in">support@keyconnect.in</a>
              <br />
              Website:{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.keyconnect.in
              </a>
            </p>
          </section>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-dark text-light text-center py-4">
        <small>
          &copy; {new Date().getFullYear()} KeyConnect CRM. All rights reserved.
        </small>
      </footer>
    </div>
  );
};

export default CancellationPolicy;